/**
 * A one-time marker for the return from Recharge Checkout: the review stores the success value it sends Stripe
 * just before leaving, and the success overlay shows only for that value, once, so Back, a reload or a shared
 * success address shows nothing. Storage that throws (blocked or private mode) fails open: Stripe redirects to
 * the success address only after payment.
 */
const RECHARGE_CHECKOUT_KEY = 'recharge-checkout';

export const markRechargeCheckout = (successValue: string) => {
  try {
    sessionStorage.setItem(RECHARGE_CHECKOUT_KEY, successValue);
  } catch {
    // Fails open on return.
  }
};

export const isMarkedRechargeReturn = (successValue: string) => {
  try {
    return sessionStorage.getItem(RECHARGE_CHECKOUT_KEY) === successValue;
  } catch {
    return true;
  }
};

export const clearRechargeCheckout = () => {
  try {
    sessionStorage.removeItem(RECHARGE_CHECKOUT_KEY);
  } catch {
    // Nothing was stored.
  }
};
